import { useState } from 'react'
import type { Customer } from '~app/graph/generated/graphql'
import EmailChangeForm from './EmailChangeForm'
import EmailQueryForm from './EmailQueryForm'

const CustomerEmailUpdate = () => {
  const [selectedUser, setSelectedUser] = useState<Customer | undefined>()

  return (
    <div>
      <EmailQueryForm onSelectionChange={setSelectedUser} />
      {selectedUser && <EmailChangeForm userId={selectedUser.id} />}
    </div>
  )
}

export default CustomerEmailUpdate
